import http from '../http'
const API_URL = "companies_items"

class CompaniesItemsAPI {

  /**
   * This method is used to get the puntuation of a company
   * @param {Number} companyID - The id of the company
   * @returns {JSON} - The JSON object with the puntuation of the company
   */
  async getPuntuation(companyID) {
    const response = await http(`${API_URL}/${companyID}`)
    return response
  }

  /**
   * This method is used to get the status item of a company
   * @param {Number} companyID - The id of the company
   * @param {Number} itemID - The id of the item
   * @returns {JSON} - The JSON object with the status of the item
   */
  async getStatus(companyID, itemID) {
    const response = await http(`items_companies`, 'POST', {
      companies_id: companyID,
      items_id: itemID
    })
    return response
  }

  async getImplemented(companyID) {
    const response = await http(`${API_URL}/show/${companyID}`)
    return response
  }

  async simpleUpdateCompanieItems(companyID,item){
    const response = await http(`items_companies/updateCompanieItems/${companyID}`,'POST',{
      items_id: item.items_id,
      status: item.status,
    })
    return response
  }

  /**
   * This method is used to update the status item of a company
   * @param {Number} companyID - The id of the company
   * @param {JSON} item - The item to update
   * @returns {JSON} - The JSON object that is the response of the request
   */
  async updateStatus(companyID, item) {

    const company = JSON.parse(localStorage.getItem('company')) || null;

    if (!company) {
      console.log('The company is required...', company)
      return
    }

    const response = await http(`items_companies/update/${companyID}`, 'POST', {
      ...item,
      company_classification_id: company.company_classification_id
    })
    return response
  }

}

export default new CompaniesItemsAPI()